/**
 * Schema of TipoOcorrencia
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'

export default (model: TipoOcorrencia): Schema => ({
  idOcorrenciaPk: {
    content: model.idOcorrenciaPk,
    editable: false,
  },

  idOcorrenciaExterna: {
    content: model.idOcorrenciaExterna,
  },

  idOcorrenciaExternaAlt: {
    model: 'idOcorrenciaExterna',
    content: model.idOcorrenciaExterna,
    textContent: null,
    input: InputType.MASK,
    meta: {
      required: true,
      mask: '###########################',
      selectall: true,
    },
  },

  nome: {
    content: model.nome,
  },

  nomeAlt: {
    model: 'nome',
    content: model.nome,
    textContent: null,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '63',
    },
  },

  ehDevolvida: {
    content: bool(model.ehDevolvida),
    input: InputType.CHECKBOX,
  },

  ehTrajeto: {
    content: bool(model.ehDevolvida),
    input: InputType.CHECKBOX,
  },

  ativo: {
    content: bool(model.ativo),
    input: InputType.CHECKBOX,
  },
})
